import React from 'react'
import { Link } from 'react-router-dom';

const Loan_Schemes2Header = () => {
    return (
        <>
            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">

                <Link to="/loan/loan-schemes-list" className="btn btn-primary">
                    <span>Back</span>
                </Link>
            </div>

        </>
    )
}

export default Loan_Schemes2Header